import ShopOutlined from '@ant-design/icons/ShopOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import TransactionOutlined from '@ant-design/icons/TransactionOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';

const icons = {
  ShopOutlined,
  SafetyCertificateOutlined,
  TransactionOutlined,
  BarChartOutlined
};

const adminMenu = {
  id: 'group-admin',
  title: 'Administração',
  type: 'group',
  children: [
    {
      id: 'admin-merchants',
      title: 'Empresas & KYC',
      type: 'item',
      url: '/admin/merchants',
      icon: icons.SafetyCertificateOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-payments',
      title: 'Pagamentos',
      type: 'item',
      url: '/admin/payments',
      icon: icons.TransactionOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-reports',
      title: 'Relatórios',
      type: 'item',
      url: '/admin/reports',
      icon: icons.BarChartOutlined,
      breadcrumbs: false
    }
  ]
};

export default adminMenu;
